import { render, staticRenderFns } from "./clnt_order.vue?vue&type=template&id=bf06b606&scoped=true"
import script from "./clnt_order.vue?vue&type=script&lang=js"
export * from "./clnt_order.vue?vue&type=script&lang=js"
import style0 from "./clnt_order.vue?vue&type=style&index=0&id=bf06b606&prod&scoped=true&lang=less"
import style1 from "./clnt_order.vue?vue&type=style&index=1&id=bf06b606&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf06b606",
  null
  
)

export default component.exports